module.exports = __webpack_public_path__ + "img/0-12.4b0c776c.jpg";